import { I18nComponente } from "@/types/gerais"

export const TSingleSignOni18n: I18nComponente = {
  "pt-BR": {
    singleSignOn: "single sign on",
    emQualAmbienteDesejaEntrar: "em qual ambiente deseja entrar?",
    nomeDaEmpresa: "nome da empresa",
    voltar: "voltar",
    continuar: "continuar"
  },
  "es-CO": {
    singleSignOn: "single sign on",
    emQualAmbienteDesejaEntrar: "en qué ambiente deseas entrar?",
    nomeDaEmpresa: "nombre de la empresa",
    voltar: "volver",
    continuar: "continuar"
  },
}
